import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { List, X } from "@phosphor-icons/react";

const navLinks = [
  { label: "Hakkımızda", href: "#hakkimizda" },
  { label: "Olanaklar", href: "#olanaklar" },
  { label: "Konaklama", href: "#konaklama" },
  { label: "Galeri", href: "#galeri" },
  { label: "Konum", href: "#konum" },
  { label: "İletişim", href: "#iletisim" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.nav
      data-testid="navbar"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F9F6F0]/90 backdrop-blur-xl shadow-[0_4px_30px_rgba(0,0,0,0.06)] border-b border-[#D1C9B8]/30"
          : "bg-transparent"
      }`}
    >
      <div className="container-main flex items-center justify-between h-20">
        <a
          data-testid="navbar-logo"
          href="#hero"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
          className="flex items-center gap-3"
        >
          <span
            className={`font-['Playfair_Display'] text-2xl font-bold tracking-tight transition-colors duration-300 ${
              scrolled ? "text-[#1A1A1A]" : "text-white"
            }`}
          >
            DVT
          </span>
          <span
            className={`font-['Outfit'] text-sm font-medium tracking-[0.15em] uppercase transition-colors duration-300 ${
              scrolled ? "text-[#4A5D23]" : "text-white/80"
            }`}
          >
            Rezidans
          </span>
        </a>

        {/* Desktop links */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.href}
              data-testid={`nav-link-${link.href.slice(1)}`}
              onClick={() => scrollTo(link.href)}
              className={`font-['Outfit'] text-sm font-medium tracking-wide transition-colors duration-300 hover:text-[#C46235] ${
                scrolled ? "text-[#4A4A4A]" : "text-white/90"
              }`}
            >
              {link.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-button"
            onClick={() => scrollTo("#iletisim")}
            className="px-6 py-2.5 bg-[#C46235] text-white text-sm font-medium rounded-full transition-all duration-300 hover:bg-[#A6522B] hover:shadow-lg hover:shadow-[#C46235]/20"
          >
            Rezervasyon
          </button>
        </div>

        {/* Mobile toggle */}
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`lg:hidden p-2 transition-colors ${scrolled ? "text-[#1A1A1A]" : "text-white"}`}
        >
          {mobileOpen ? <X size={28} weight="bold" /> : <List size={28} weight="bold" />}
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-[#F9F6F0]/95 backdrop-blur-xl border-b border-[#D1C9B8]/50 overflow-hidden"
          >
            <div className="container-main py-6 flex flex-col gap-4">
              {navLinks.map((link) => (
                <button
                  key={link.href}
                  data-testid={`mobile-nav-${link.href.slice(1)}`}
                  onClick={() => scrollTo(link.href)}
                  className="font-['Outfit'] text-base font-medium text-[#1A1A1A] text-left py-2 border-b border-[#D1C9B8]/30 transition-colors hover:text-[#C46235]"
                >
                  {link.label}
                </button>
              ))}
              <button
                data-testid="mobile-cta-button"
                onClick={() => scrollTo("#iletisim")}
                className="mt-2 px-6 py-3 bg-[#C46235] text-white text-sm font-semibold rounded-full w-full"
              >
                Rezervasyon
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;
